import React from 'react'

import './style.scss'

const FAB = props => {
  const { setVisibleVideo } = props

  return (
    <button
      className="floating-action-button"
      type="button"
      aria-label="Load more results"
      onClick={() => setVisibleVideo(prevState => prevState + prevState)}
    >
      <span>+ more</span>
    </button>
  )
}

export default FAB